import React from "react";
import { Form, Row, Col } from "react-bootstrap";

function UnavailableOperationCard({ operation }) {
  const batchSize = operation.settings[0].min; // Размер партии по умолчанию
  const selectedGroup = operation.settings[0].group_id; // Выбранная группа по умолчанию

  return (
    <div className="card border-danger mb-3">
      <div className="card-header bg-danger text-white">
        <h5 className="mb-0">{operation.operation_name} (Недоступно)</h5>
      </div>
      <div className="card-body text-danger">
      <Row className="text-center mb-3">
          <Col>
            <p className="mb-0">
              <strong>Размещено:</strong>
            </p>
            <p>
              {operation.placed_quantity} из {operation.total_quantity}
            </p>
          </Col>
          <Col>
            <p className="mb-0">
              <strong>Доступно:</strong>
            </p>
            <p>{operation.ready_quantity}</p>
          </Col>
          <Col style={{justifyItems: "center"}}>
            <p className="mb-0">
              <strong>Разместить:</strong>
            </p>
            <Form.Control type="number" value={0} disabled  />
          </Col>
        </Row>
        <Form.Group controlId="parallelProcessing" className="mt-3">
          <Form.Label>Группа оборудования</Form.Label>
          <Form.Select value={selectedGroup} disabled>
            {operation.settings.map((setting) => (
              <option key={setting.group_id} value={setting.group_id}>
                {setting.group_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Row className="mt-3 align-items-center">
          <Col xs={12}>
            <Form.Label>Размер партии для параллельной обработки</Form.Label>
          </Col>
          <Col xs="auto">
            <Form.Label className="text-muted">MIN: {operation.settings[0].min}</Form.Label>
          </Col>
          <Col>
            <Form.Range
              min={operation.settings[0].min}
              max={operation.settings[0].max}
              value={batchSize}
              disabled
            />
          </Col>
          <Col xs="auto">
            <Form.Label className="text-muted">MAX: {operation.settings[0].max}</Form.Label>
          </Col>
          <Col xs="auto" className="text-center">
            <Form.Control
              type="number"
              value={batchSize}
              readOnly
              className="text-center"
              style={{ width: "80px", margin: "0 auto" }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default UnavailableOperationCard;
